import React from 'react';
import { BuildOutlined, ThunderboltOutlined, DollarOutlined, RocketOutlined } from '@ant-design/icons';

interface Advantage {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  features: string[];
}

const AdvantagesSection: React.FC = () => {
  const advantages: Advantage[] = [
    {
      id: 1,
      title: "技术架构领先",
      description: "与BBAT同源的领域微服务设计，架构是一切的基础！",
      icon: <BuildOutlined style={{ fontSize: '1.5rem', color: '#60a5fa' }} />,
      features: [
        "来自字节、百度、阿里等大厂架构师、技术专家多年架构经验",
        "后端参考DDD分层设计，按领域划分微服务，更具安全性",
        "APP数据库管理与性能优化，确保极速体验，一眼大厂出品", 
        "久经考验的基础框架，无需重复造轮子，直接使用"
      ]
    },
    {
      id: 2,
      title: "成本优势明显",
      description: "80%开发者来自圆领卖家+人人都精通AI工具",
      icon: <DollarOutlined style={{ fontSize: '1.5rem', color: '#10b981' }} />,
      features: [
        "圆领卖家开发者大多为大城市返乡人才，技术强，成本低",
        "统一AI工具使用培训，确保每个人都善于用AI提高自身效能",
        "人才自己购买Cursor、Claude Code、Trea等工具，无需客户承担",
        "大部分卖家开发者都已经熟悉开发流程，无学习成本"
      ]
    },
    {
      id: 3,
      title: "支持托管运维",
      description: "可委托圆领负责技术运营和维护，您只需专注业务！",
      icon: <ThunderboltOutlined style={{ fontSize: '1.5rem', color: '#a855f7' }} />,
      features: [
        "客户可自愿选择由圆领来负责技术运营和维护",
        "部分项目可通过分佣模式支付研发费用，节省大量技术成本",
        "无需关心任何技术问题，圆领统一负责，客户只需专注自身业务",
        "平台具备多年大流量平台运营和维护经验，技术水平值得信任"
      ]
    },
    
    {
      id: 4,
      title: "交付速度极快",
      description: "小项目定期演示成果，大项目每日演示昨日成果！",
      icon: <RocketOutlined style={{ fontSize: '1.5rem', color: '#f59e0b' }} />,
      features: [
        "项目中的每个人都要定期演示成果，无需担心划水、拖延。 ",
        "对于复杂多变的项目，每日演示最新效果，发现问题及时调整。",
        "成果的演示采用视频会议投屏的方式，在家就能轻松掌控进度",
        "晦涩问题会第一时间发起语音/视频沟通，针对性充分讨论"
      ]
    }
  ];

  const sectionStyle: React.CSSProperties = {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#000000',
    overflow: 'hidden',
  };

  const containerStyle: React.CSSProperties = {
    maxWidth: '1000px',
    width: '100%',
    padding: '0 2rem',
    position: 'relative',
    zIndex: 2,
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#ffffff',
    textAlign: 'center',
    marginBottom: '0.5rem',
    background: 'linear-gradient(135deg, #60a5fa 0%, #a855f7 50%, #ec4899 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  };

  const subtitleStyle: React.CSSProperties = {
    fontSize: '1.125rem',
    color: '#94a3b8',
    textAlign: 'center',
    marginBottom: '2rem',
    fontWeight: 300,
  };

  const gridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '1.5rem',
  };

  const cardStyle: React.CSSProperties = {
    background: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '0',
    padding: '1rem 1rem',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    height: '100%',
  };

  const cardIconStyle: React.CSSProperties = {
    marginRight: '0.6rem',
    display: 'inline-flex',
    alignItems: 'center',
  };

  const cardTitleStyle: React.CSSProperties = {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#ffffff',
    marginBottom: '0.6rem',
    display: 'flex',
    alignItems: 'center',
    marginTop: '0',
  };

  const cardDescriptionStyle: React.CSSProperties = {
    fontSize: '0.9rem',
    color: '#94a3b8',
    marginBottom: '1rem',
    lineHeight: 1.4,
  };

  const featureListStyle: React.CSSProperties = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  };

  const featureItemStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.4rem',
    fontSize: '0.8rem',
    color: '#cbd5e1',
  };

  const featureDotStyle: React.CSSProperties = {
    width: '5px',
    height: '5px',
    backgroundColor: '#60a5fa',
    borderRadius: '50%',
    marginRight: '0.6rem',
    flexShrink: 0,
  };
 

  return (
    <>
      <style>
        {`
          .advantage-card {
            transition: all 0.3s ease;
          }
          
          .advantage-card:hover {
            transform: translateY(-10px);
            background: rgba(255, 255, 255, 0.08) !important;
            border-color: rgba(96, 165, 250, 0.3) !important;
            box-shadow: 0 20px 40px rgba(96, 165, 250, 0.1) !important;
          }
          
          .advantage-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, #60a5fa, #a855f7, #ec4899);
            opacity: 0;
            transition: opacity 0.3s ease;
          }
          
          .advantage-card:hover::before {
            opacity: 1;
          }

                                @media (max-width: 768px) {
             .advantages-section {
               height: auto !important;
               min-height: 100vh !important;
               padding: 4rem 0 !important;
               display: block !important;
             }
             
             .advantages-title {
               font-size: 2rem !important;
             }
             
             .advantages-subtitle {
               font-size: 1rem !important;
               margin-bottom: 2rem !important;
             }
             
             .advantages-grid {
               grid-template-columns: 1fr !important;
               gap: 1.5rem !important;
             }
             
             .advantage-card {
               padding: 1.5rem !important;
               height: auto !important;
             }
           }

           @media (max-width: 480px) {
             .advantages-title {
               font-size: 1.75rem !important;
             }
             
             .advantages-container {
               padding: 0 1rem !important;
             }
             
             .advantages-section {
               padding: 3rem 0 !important;
             }
           }
        `}
      </style>

      <section style={sectionStyle} className="advantages-section"> 
        
        <div style={containerStyle} className="advantages-container">
          <h2 style={titleStyle} className="advantages-title">
            核心技术优势
          </h2>
          <p style={subtitleStyle} className="advantages-subtitle">
            领先的技术架构 × 极致的成本控制 × 拎包入住的快感 × 快速的交付能力
          </p>
          
          <div style={gridStyle} className="advantages-grid">
            {advantages.map((advantage) => (
              <div
                key={advantage.id}
                                 style={cardStyle}
                 className="advantage-card"
               >
                                  <h3 style={cardTitleStyle}>
                   <div style={cardIconStyle}>{advantage.icon}</div>
                   {advantage.title}
                 </h3>
                <p style={cardDescriptionStyle}>{advantage.description}</p>
                
                <ul style={featureListStyle}>
                  {advantage.features.map((feature, index) => (
                    <li 
                      key={index} 
                      style={{
                        ...featureItemStyle,
                        marginBottom: index === advantage.features.length - 1 ? '0' : '0.4rem'
                      }}
                    >
                      <div style={featureDotStyle}></div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AdvantagesSection; 